import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Card, CardContent } from '../components/ui/Card';
function RichTextEditor({
  label,
  defaultValue = '',
  highlighted = false
}: {
  label: string;
  defaultValue?: string;
  highlighted?: boolean;
}) {
  return <div data-id="element-619" data-mp="vorebi25bial">
      <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-620" data-mp="vohnjs9a173u">
        {label}
      </label>
      <div className="border border-slate-300 rounded-md overflow-hidden" data-id="element-621" data-mp="qqz95mchpzog">
        {/* Toolbar row 1 */}
        <div className="flex items-center gap-0.5 px-2 py-1 bg-slate-100 border-b border-slate-300 flex-wrap" data-id="element-622" data-mp="14oxn4qmwfu3f">
          <button type="button" className="px-1.5 py-0.5 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-623" data-mp="10poszkny5u7c">
            Source
          </button>
          <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-624" data-mp="32hjr0xha6073" />
          {['📄', '📋', '✂', '🗑', '↩', '↪'].map((ic, i) => <button key={i} type="button" className="px-1 py-0.5 text-xs border border-transparent hover:border-slate-300 hover:bg-white rounded text-slate-500" data-id="element-625" data-mp="2eqmgpux58to3" data-mpi={i}>
              {ic}
            </button>)}
          <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-626" data-mp="2tiy50y4m1lrp" />
          {['🔍', '🔤', '🖊'].map((ic, i) => <button key={i} type="button" className="px-1 py-0.5 text-xs border border-transparent hover:border-slate-300 hover:bg-white rounded text-slate-500" data-id="element-627" data-mp="2yfx0bk00fyrh" data-mpi={i}>
              {ic}
            </button>)}
        </div>
        {/* Toolbar row 2 */}
        <div className="flex items-center gap-0.5 px-2 py-1 bg-slate-100 border-b border-slate-300 flex-wrap" data-id="element-628" data-mp="3ce50e0scfg6v">
          {['B', 'I', 'U', 'S'].map(t => <button key={t} type="button" className="w-6 h-6 text-xs font-bold border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-700" data-id="element-629" data-mp="1i39ho5ng2kqd">
              {t}
            </button>)}
          <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-630" data-mp="1jzooqabtwei5" />
          {['≡', '≣', '❝', '»'].map((t, i) => <button key={i} type="button" className="w-6 h-6 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-631" data-mp="1f0v8wb92kbet" data-mpi={i}>
              {t}
            </button>)}
          <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-632" data-mp="1oy9n047iso3y" />
          <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-633" data-mp="22qpkkphnjtxh">
            <option data-id="element-634" data-mp="1xrcyi6yluqvy">Styles</option>
          </select>
          <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-635" data-mp="1xrmp9wrh522p">
            <option data-id="element-636" data-mp="2cp58ykpaop3a">Format</option>
          </select>
          <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-637" data-mp="27piy2hwxvkxn">
            <option data-id="element-638" data-mp="2rb2oya384uzr">Font</option>
          </select>
          <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-639" data-mp="2rcdqs4d3zso8">
            <option data-id="element-640" data-mp="2vbmmherpm0mf">Size</option>
          </select>
          <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-641" data-mp="2vabf74z22aqk" />
          {['A', 'A', '⊞', '⊟', '⊕', '?'].map((t, i) => <button key={i} type="button" className="w-6 h-6 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-642" data-mp="2mbprywin27jg" data-mpi={i}>
              {t}
            </button>)}
        </div>
        {/* Editor area */}
        <textarea className={`w-full p-3 text-sm focus:outline-none resize-y min-h-[140px] ${highlighted ? 'bg-pink-50' : 'bg-white'}`} defaultValue={defaultValue} data-id="element-643" data-mp="1ymdhzufhlvg3" />
      </div>
    </div>;
}
const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const days = Array.from({
  length: 31
}, (_, i) => String(i + 1));
const years = Array.from({
  length: 10
}, (_, i) => String(2026 - i));
const hours = Array.from({
  length: 12
}, (_, i) => String(i + 1));
const minutes = Array.from({
  length: 60
}, (_, i) => String(i).padStart(2, '0'));
const fullDescDefault = `SECTION 3: More Clauses and Contingencies

Most purchase contracts for residential real estate will allow both parties time to review certain documents to determine their desire to move forward. While the seller typically has limited review options, the buyer is often allowed a pre-determined period to review numerous items, including but not limited to:

• Finance options
• Community and homeowner's association documents
• Title and escrow procedures
• Insurance options and possible obligations (such as flood insurance)
• Property condition and issues included value, zoning, land use, etc.`;
export function EditCourseSection() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const isEdit = !!id;
  return <div className="space-y-4" data-id="element-644" data-mp="50izdxztdevj">
      <div className="flex items-center justify-between" data-id="element-645" data-mp="a16q0ik4rtp8">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-646" data-mp="9zlwmw9jygsy">
          {isEdit ? 'Edit Section' : 'Add Section'}
        </h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/sections')} data-id="element-647" data-mp="jri4gz1fxlad">
          ← Back to Sections
        </Button>
      </div>

      <Card data-id="element-648" data-mp="3s7bbmn9vtker">
        <CardContent className="pt-6" data-id="element-649" data-mp="3s7l6op9sahrb">
          <form className="space-y-5 max-w-2xl" data-id="element-650" data-mp="3s6iac1tozn40">
            <Input label="Name" defaultValue={isEdit ? 'Section 3' : ''} className="max-w-xs" data-id="element-651" data-mp="10qq1j2lj4p4" />

            <RichTextEditor label="Small Description" defaultValue="" data-id="element-652" data-mp="17gklq5s5xc4c" />

            <RichTextEditor label="Full Description" defaultValue={isEdit ? fullDescDefault : ''} highlighted={isEdit} data-id="element-653" data-mp="1cfe0s2n3lb6m" />

            {isEdit && <div data-id="element-654" data-mp="33j5to09z4vy8">
                <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-655" data-mp="33jpbzi3jdmcs">
                  Bg Color
                </label>
                <input type="text" defaultValue="#FCCCC" className="h-8 w-32 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-656" data-mp="3hhnosj27laq6" />
              </div>}

            <div data-id="element-657" data-mp="2krmuk4j2m21h">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-658" data-mp="2yl4brioab2oc">
                Question Types
              </label>
              <select defaultValue="Multiple" className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-659" data-mp="2ttcvc0yuedbx">
                <option value="Multiple" data-id="element-660" data-mp="222q98q5nijve">Multiple</option>
                <option value="TrueFalse" data-id="element-661" data-mp="1rzkufou8fwf0">True/False</option>
                <option value="Essay" data-id="element-662" data-mp="1rx86mv1smru1">Essay</option>
              </select>
            </div>

            <div data-id="element-663" data-mp="1wrcfxkyj7bya">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-664" data-mp="1wrul573690ic">
                Required Time
              </label>
              <input type="text" defaultValue={isEdit ? '25' : ''} className="h-8 w-24 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-665" data-mp="1mzotjygu0l3o" />
            </div>

            <div data-id="element-666" data-mp="20rmuhm0e3aor">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-667" data-mp="20s4qchj53mw5">
                Position
              </label>
              <input type="text" defaultValue="" className="h-8 w-24 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-668" data-mp="25pem0ex4gusf" />
            </div>

            {isEdit && <div data-id="element-669" data-mp="bm1khxpnrl5x">
                <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-670" data-mp="bml4djyvcjml">
                  Created
                </label>
                <div className="flex items-center gap-1 flex-wrap" data-id="element-671" data-mp="6o9rt1h6vv0o">
                  <select defaultValue="June" className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-672" data-mp="1ncb6tbtv91a">
                    {months.map(m => <option key={m} data-id="element-673" data-mp="pc538epbwwqm">{m}</option>)}
                  </select>
                  <select defaultValue="30" className="h-8 w-16 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-674" data-mp="kkwttio01bdg">
                    {days.map(d => <option key={d} data-id="element-675" data-mp="18bizj3aj6jka">{d}</option>)}
                  </select>
                  <select defaultValue="2025" className="h-8 w-20 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-676" data-mp="2qyaeui6crzv7">
                    {years.map(y => <option key={y} data-id="element-677" data-mp="3011uku69hhsn">{y}</option>)}
                  </select>
                  <select defaultValue="2" className="h-8 w-14 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-678" data-mp="34vpc292ulbxq">
                    {hours.map(h => <option key={h} data-id="element-679" data-mp="3jn7wcj2qpsmw">{h}</option>)}
                  </select>
                  <select defaultValue="49" className="h-8 w-16 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-680" data-mp="3nnrunpz1v2am">
                    {minutes.map(m => <option key={m} data-id="element-681" data-mp="15z4wm2ngbcnj">{m}</option>)}
                  </select>
                  <select defaultValue="pm" className="h-8 w-16 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-682" data-mp="1ay82tqf63ox3">
                    <option value="am" data-id="element-683" data-mp="1jqruu80yev8y">am</option>
                    <option value="pm" data-id="element-684" data-mp="1op352jv5v7rp">pm</option>
                  </select>
                </div>
              </div>}

            <div className="pt-2" data-id="element-685" data-mp="1tmcysbpl25lc">
              <Button type="submit" data-id="element-686" data-mp="1tphcq0suofp7">Submit</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}